import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PipeModule } from 'src/app/pipe.module';
import {
  DxButtonModule,
  DxFileUploaderModule,
  DxFormModule,
  DxGalleryModule,
} from 'devextreme-angular';
import { StaticRoutesModule } from './static-routes.module';
import { FormsModule } from '@angular/forms';

import { MedigiRequestDemoComponent } from './medigi/request-demo/request-demo.component';
import { MedigiHomeComponent } from './medigi/home/home.component';
import { MedigiRegistrationComponent } from './medigi/registration/registration.component';
import { MedigiPharamacyInfoComponent } from './medigi/pharamacy-info/pharamacy-info.component';
import { MeidigiManufacturerInfoComponent } from './medigi/manufacturer-info/manufacturer-info.component';
import { MedigiAboutComponent } from './medigi/about/about.component';

import { MedshortsRequestDemoComponent } from './medshorts/request-demo/request-demo.component';
import { MedshortsAboutComponent } from './medshorts/about/about.component';
import { MedshortsPharmacyInfoComponent } from './medshorts/pharma-info/pharma-info.component';
import { MedshortsManufactureInfoComponent } from './medshorts/manufacture-info/manufacture-info.component';
import { MedshortsContactComponent } from './medshorts/contact/contact.component';
import { MedshortsHomeComponent } from './medshorts/home/home.component';
import { MedshortsRegistrationComponent } from './medshorts/registration/registration.component';

import { OutsourcingHomeComponent } from './503B/home/home.component';
import { OutsourcingInfoComponent } from './503B/outsourcing-info/outsourcing-info.component';
import { OutsourcingPharmacyInfoComponent } from './503B/pharmacy-info/pharmacy-info.component';
import { OutsourcingRegistrationComponent } from './503B/registration/registration.component';

import { SellerDirectComponent } from './seller-direct/seller-direct.component';
import { DirectModule } from 'src/app/shared/components/direct/direct.module';

import { HomeComponent } from './page-containers/home/home.component';
import { RequestDemoComponent } from './page-containers/request-demo/request-demo.component';
import { AboutComponent } from './page-containers/about/about.component';
import { PharmacyInfoComponent } from './page-containers/pharmacy-info/pharmacy-info.component';
import { ManufacturerInfoComponent } from './page-containers/manufacturer-info/manufacturer-info.component';
import { ContactComponent } from './page-containers/contact/contact.component';
import { RegisterComponent } from './page-containers/register/register.component';
import { StaticFooterModule } from 'src/app/layouts/static-footer/static-footer.component';

import { LaptopVideoComponent } from './components/laptop-video/laptop-video.component';
import { StepCardComponent } from './components/cards/step-card/step-card.component';
import { LargeCardComponent } from './components/cards/large-card/large-card.component';
import { ButtonComponent } from './components/button/button.component';
import { ValuePropComponent } from './components/value-prop/value-prop.component';
import { TransparentCardComponent } from './components/cards/transparent-card/transparent-card.component';
import { FaqComponent } from './components/faq/faq.component';
import { DrugCardComponent } from './components/cards/drug-card/drug-card.component';
import { CarouselComponent } from './components/carousel/carousel.component';
import { CityBadgesComponent } from './components/city-badges/city-badges.component';
import { EmployeeCardComponent } from './components/cards/employee-card/employee-card.component';
import { StaticFormComponent } from './components/button/static-form/static-form.component';
import { TimelineCardComponent } from './components/cards/timeline-card/timeline-card.component';

@NgModule({
  imports: [
    CommonModule,
    DxButtonModule,
    StaticRoutesModule,
    StaticFooterModule,
    PipeModule,
    DirectModule,
    DxGalleryModule,
    DxFormModule,
    DxFileUploaderModule,
    FormsModule,
  ],
  declarations: [
    MedigiHomeComponent,
    MedigiRequestDemoComponent,
    MedigiRegistrationComponent,
    MedigiPharamacyInfoComponent,
    MeidigiManufacturerInfoComponent,
    MedigiAboutComponent,

    MedshortsRequestDemoComponent,
    MedshortsAboutComponent,
    MedshortsPharmacyInfoComponent,
    MedshortsManufactureInfoComponent,
    MedshortsContactComponent,
    MedshortsRegistrationComponent,
    MedshortsHomeComponent,

    OutsourcingHomeComponent,
    OutsourcingInfoComponent,
    OutsourcingPharmacyInfoComponent,
    OutsourcingRegistrationComponent,

    HomeComponent,
    RequestDemoComponent,
    AboutComponent,
    PharmacyInfoComponent,
    ManufacturerInfoComponent,
    ContactComponent,
    RegisterComponent,

    SellerDirectComponent,

    LaptopVideoComponent,
    StepCardComponent,
    LargeCardComponent,
    ButtonComponent,
    ValuePropComponent,
    TransparentCardComponent,
    FaqComponent,
    DrugCardComponent,
    CarouselComponent,
    CityBadgesComponent,
    EmployeeCardComponent,
    StaticFormComponent,
    TimelineCardComponent,
  ],
  exports: [MedigiHomeComponent, SellerDirectComponent],
})
export class StaticModule {}
